var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('span',{staticClass:"cursor-pointer",on:{"click":function($event){return _vm.onClick()}}},[_c('Icon',{staticClass:"location",attrs:{"color":"primary","small":"","type":"location"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }